export default __webpack_public_path__ + "static/media/artist_eben.83624d95.jpg";